import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import OSShell from "@/pages/OSShell";
import Preview from "@/pages/Preview";
import RealtimeVoiceOrb from "@/components/RealtimeVoiceOrb";
import InstallPrompt from "@/components/InstallPrompt";
import GoogleAuthCallback from "@/components/GoogleAuthCallback";
import { LoginModal } from "@/components/LoginModal";
import { VoiceSessionProvider } from "@/context/VoiceSessionContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { useEffect } from "react";

function AdminRoute({ children }) {
  const { isAdmin, isAuthenticated, loading, setShowLoginModal } = useAuth();
  useEffect(() => {
    if (!loading && !isAuthenticated) setShowLoginModal(true);
  }, [loading, isAuthenticated, setShowLoginModal]);
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

function AuthedVoiceOrb() {
  const { isAdmin } = useAuth();
  // The realtime Voice Orb hits admin-only endpoints (ephemeral session, function-calling
  // launch tool) - guests get a text-only chat instead, so the orb never mounts for them.
  return isAdmin ? <RealtimeVoiceOrb /> : null;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      {/* Standalone Google OAuth return leg - Google redirects here with ?code & ?state. */}
      <Route path="/auth/google" element={<GoogleAuthCallback />} />
      <Route path="/os" element={<AdminRoute><OSShell /></AdminRoute>} />
      <Route path="/preview" element={<Preview />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <VoiceSessionProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <AuthedVoiceOrb />
          <LoginModal />
          <InstallPrompt />
        </VoiceSessionProvider>
      </AuthProvider>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
